module.exports = new __parcel__URL__("rat-boss.266167ed.webp").toString();